import { use } from "react";
import { Outlet } from "react-router";

import { Navigation } from "@/components/Trajectory";
import PageWrapper from "@/components/ui/PageWrapper";
import { FeaturesContext } from "@/contexts";

function Trajectory() {
  const { featureFlags } = use(FeaturesContext);

  if (!featureFlags?.trajectory_v2) {
    return null;
  }

  return (
    <PageWrapper>
      <div className="px-xl py-lg">
        <Navigation />
        <Outlet />
      </div>
    </PageWrapper>
  );
}

export default Trajectory;
